import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import axios from 'axios'

class LogoutFunction extends Component {
    componentDidMount() {
        axios
            .get(`/auth/logout`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                Auth.deauthenticateUser()
                this.props.toggleAuthenticateStatus()
                this.props.cookies.remove('project_status')
                this.props.cookies.remove('project_name')
                this.props.cookies.remove('project')
                this.props.cookies.remove('project_role')
                this.props.cookies.remove('demo')
                this.props.cookies.remove('token')

                const appName = this.props.cookies.get('app_name')
                if (appName === '' || appName === 'undefined' || appName === 'hausplanner') {
                    window.location.href = '/main'
                } else {
                    window.location.href = '/login'
                }
            })
            .catch((err) => {
                console.log(err)
                Auth.deauthenticateUser()
                this.props.toggleAuthenticateStatus()
                this.props.cookies.remove('project_status')
                this.props.cookies.remove('project_name')
                this.props.cookies.remove('project')
                this.props.cookies.remove('project_role')
                this.props.cookies.remove('demo')
                this.props.cookies.remove('token')

                const appName = this.props.cookies.get('app_name')
                if (appName === '' || appName === 'undefined' || appName === 'hausplanner') {
                    window.location.href = '/main'
                } else {
                    window.location.href = '/login'
                }
            })
    }

    render() {
        return (
            <div>
                <div className="section_wrap">
                    <div></div>
                </div>
            </div>
        )
    }
}

export default withCookies(LogoutFunction)



// WEBPACK FOOTER //
// ./Src/Containers/User/LogoutFunction.js